import PillTabs from 'components/tabs/PillTabs';
import useHomeText from 'hooks/useHomeText';

/**
 * The tabs of « Tâches du jour »: all, appointments, calls and the tasks, each
 * with what is left to do (`counts`, pages/home/homeItems `countOpenItems`).
 * « Appels » is the call list: a role without one (`showCalls` false) has no
 * such tab. On a phone they stay on one line and scroll sideways.
 */
const TaskTabs = ({ value, counts, onChange, showCalls = true }) => {
  const { text } = useHomeText();
  return (
    <div className="shrink-0 overflow-x-auto [&_span]:whitespace-nowrap">
      <PillTabs
        activeTab={value}
        onChange={onChange}
        tabs={[
          { id: 'all', label: text('tasks.tabAll'), count: counts.all },
          { id: 'appointments', label: text('tasks.tabAppointments'), count: counts.appointments },
          showCalls && { id: 'calls', label: text('tasks.tabCalls'), count: counts.calls },
          { id: 'other', label: text('tasks.tabOther'), count: counts.other },
        ].filter(Boolean)}
      />
    </div>
  );
};

export default TaskTabs;
